import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { AssistantFooter } from './assistant-footer';
import { AgentFab } from './agent-fab';

/**
 * Flag switch for the agent entry point: the floating launcher (with the
 * multi-conversation menu) or today's "Ask agent" footer bar.
 */
export function AgentLauncher() {
  const isFloatingLauncherEnabled = useFeatureFlag(AccountFeatureFlag.AgentFloatingLauncher);

  return isFloatingLauncherEnabled ? <AgentFab /> : <AssistantFooter />;
}
